'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _pcSlateTools = require('./../process/pc-slate-tools');

var _ShopifySection2 = require('./../sections/ShopifySection');

var _Responsive = require('./../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

var _VariantSelector = require('../objects/variant/VariantSelector');

var _ProductTemplateQuantitySelector = require('./../objects/quantity/ProductTemplateQuantitySelector');

var _AddToCartButton = require('./../objects/product/AddToCartButton');

require('./../sections/product-image-carousel/ProductImageCarousel');

require('./../sections/product-info/ProductInfo');

require('./../sections/blog-carousel/BlogCarousel');

require('./../sections/recently-viewed/RecentlyViewed');

require('./../sections/related-products/RelatedProducts');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Selectors
var PRODUCT_TEMPLATE_CONTAINER = '[data-product-template]'; /*
                                                             *  Product Template Scripts
                                                             *    Scripts that are only meant to run on the Product Template.
                                                             *
                                                             *  Version:
                                                             *    1.0.0 - 2020/03/12
                                                             */

var PRODUCT_MONEY = '[data-product-money]';
var PRODUCT_COMPARE_MONEY = '[data-product-compare-money]';
var PRODUCT_ADD = '[data-product-template-add-to-cart]';
var PRODUCT_SPECS_BTN = '[data-product-specs-btn]';
var PRODUCT_ADD_CONTAINER = '[data-product-add-container]';
var PRICING_TIERS = '[data-pricing-tiers]';

var ProductTemplate = function (_ShopifySection) {
  (0, _inherits3.default)(ProductTemplate, _ShopifySection);

  function ProductTemplate(container) {
    (0, _classCallCheck3.default)(this, ProductTemplate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductTemplate.__proto__ || Object.getPrototypeOf(ProductTemplate)).call(this, container));

    _this.container = container;
    _this.productJson = JSON.parse(container.find('[data-product-json]').html());
    _this.cookies = 'recently_viewed';
    _this.addContainer = container.find(PRODUCT_ADD_CONTAINER);

    //Add cookie for recently viewed products section
    _this.setCookies();

    _this.toggleAddToCartContainer();

    //Setup Product Quantity Selector and Add to cart
    _this.variantSelector = new _VariantSelector.VariantSelector(_this.container);
    _this.quantitySelector = new _ProductTemplateQuantitySelector.ProductTemplateQuantitySelector(_this, _this.container);
    _this.addToCart = new _AddToCartButton.AddToCartButton(_this, _this.container.find(PRODUCT_ADD), _this.container.find(PRICING_TIERS), _this.productJson);
    container.on('click touchend', PRODUCT_SPECS_BTN, function (e) {
      return _this.scrollToSpecs(e);
    });
    (0, _jquery2.default)(window).on('scroll resize orientationchange', function () {
      return _this.toggleAddToCartContainer();
    });
    return _this;
  }

  (0, _createClass3.default)(ProductTemplate, [{
    key: 'setCookies',
    value: function setCookies() {
      // Cookies.remove(this.cookies);
      var recentlyViewed = [this.productJson];
      if (_jsCookie2.default && _jsCookie2.default.get(this.cookies) != undefined) {
        var retrievedCookies = JSON.parse(_jsCookie2.default.get(this.cookies));
        recentlyViewed = [].concat((0, _toConsumableArray3.default)(recentlyViewed), (0, _toConsumableArray3.default)(retrievedCookies));
        recentlyViewed = [].concat((0, _toConsumableArray3.default)(new Set(recentlyViewed))); //filter out duplicates
      }
      _jsCookie2.default.set(this.cookies, JSON.stringify(recentlyViewed));
    }
  }, {
    key: 'scrollToSpecs',
    value: function scrollToSpecs(e) {
      e.preventDefault(), e.stopPropagation();
      var specs = (0, _jquery2.default)('[data-product-info]').find('[data-accordion-title][data-index="1"]');
      var firstAccordion = (0, _jquery2.default)('[data-product-info]').find('[data-specs-accordion-first]');
      if (!specs.parent().hasClass('is-expanded')) specs.click();
      if (!firstAccordion.parent().hasClass('is-expanded')) firstAccordion.click();
      setTimeout(function () {
        return (0, _jquery2.default)('body,html').animate({ scrollTop: specs.offset().top }, 200);
      }, 200);
    }
  }, {
    key: 'toggleAddToCartContainer',
    value: function toggleAddToCartContainer() {
      var _this2 = this;

      //Hide fixed add to cart container when it reaches the bottom of the product info section
      if (this.scrollTimeout) return;
      this.scrollTimeout = setTimeout(function () {
        _this2.scrollTimeout = null;
        var infoContainer = (0, _jquery2.default)('[data-product-info]');
        var bottom_of_container = infoContainer.offset().top + infoContainer.height();
        var bottom_of_element = _this2.addContainer.offset().top + _this2.addContainer.height();

        _this2.addContainer.removeClass('is-hidden');
        if (bottom_of_element > bottom_of_container) _this2.addContainer.addClass('is-hidden');

        var top = (0, _jquery2.default)('[data-product-image-carousel-container]').offset().top - (0, _jquery2.default)(window).scrollTop();
        if (top < 100) top = 100;
        _this2.addContainer.css('top', top);

        if ((0, _jquery2.default)(window).width() < ResponsiveSizes.medium) return _this2.addContainer.css('width', '100%');
        _this2.addContainer.css('width', _this2.container.width() * 0.25); //correct width of fixed position element
      }, 100);
    }
  }]);
  return ProductTemplate;
}(_ShopifySection2.ShopifySection);

(0, _ShopifySection2.register)(PRODUCT_TEMPLATE_CONTAINER, ProductTemplate);